import { useState, useEffect, FC } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, Typography, Dialog, DialogTitle, DialogContent, Avatar, Tooltip, Chip } from '@mui/material';
import { IconCameraUp } from '@tabler/icons-react';
import dayjs from "dayjs";
import "dayjs/locale/ru";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Link } from 'react-router-dom';
import { palette } from 'src/theme/style/palette';
import { ReturnBalance } from 'src/components/return-balance/ReturnBalance';
import { ReturnNumber } from 'src/components/return-balance/ReturnNumber';
import { TimerForTable } from './TimerForTable';
import { LoadImgForAds } from './LoadImgForAds';

dayjs.locale("ru");


// const generateData = () => {
//     const generatedData = [];
//     for (let i = 1; i <= 50; i++) {
//         const createdAt = new Date();
//         const futureTime = new Date(createdAt.getTime() + 40 * 60000); // 40 минут в будущем
//         generatedData.push({
//             id: i,
//             amount: Math.floor(Math.random() * 10000) + 100,
//             currency: ['USD', 'EUR', 'RUB'][Math.floor(Math.random() * 3)],
//             date: createdAt.toISOString(),
//             status: ['Ждет оплату', 'Ждет подтверждения', 'Подтвержден'][Math.floor(Math.random() * 3)],
//             sellerLogin: ['john_doe', 'jane_smith', 'sam_johnson', 'lisa_white', 'michael_brown'][Math.floor(Math.random() * 5)],
//             expiresAt: futureTime.toISOString(),
//         });
//     }
//     return generatedData;
// };

interface IP2pBookingTable {
    data: { data: any[], current_page: number, last_page: number }
    updateReload?: () => void
}

export const P2pBookingTable: FC<IP2pBookingTable> = ({ data: dataArray, updateReload }) => {
    const [filteredData, setFilteredData] = useState<any[] | undefined>(undefined);
    // const [currentPage, setCurrentPage] = useState(1);
    const [activeAds, setActiveAds] = useState<any>(undefined);
    const [openModal, setOpenModal] = useState(false);

    const updateStateModal = (state = !openModal) => {
        setOpenModal(state);
    }

    useEffect(() => {
        setFilteredData(dataArray.data);
        // updateReload()
    }, []);

    return (
        <>
            <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><Typography variant='h6'>ID</Typography></TableCell>
                            <TableCell><Typography variant='h6'>Сумма покупки</Typography></TableCell>
                            <TableCell><Typography variant='h6'>Сумма в валюте</Typography></TableCell>
                            <TableCell><Typography variant='h6'>Дата создания</Typography></TableCell>
                            <TableCell><Typography variant='h6'>Статус</Typography></TableCell>
                            <TableCell><Typography variant='h6'>Логин продавца</Typography></TableCell>
                            <TableCell><Typography variant='h6'>Время</Typography></TableCell>
                            <TableCell><Typography variant='h6'></Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData && filteredData.map((row, index) => {


                            const isWaitingForPayment = row.status_id === 'Ожидает оплату';

                            return (
                                <TableRow
                                    key={row.id}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? palette.lightWhiteBg : palette.blueLight,
                                        transition: 'background-color 0.3s ease',
                                        '&:hover': { backgroundColor: palette.infoLight },
                                    }}
                                >
                                    <TableCell>
                                        <Typography variant='h6'>
                                            {row.id}
                                        </Typography>
                                    </TableCell>
                                    <TableCell><Typography sx={{ fontWeight: 500 }} variant='h6'><ReturnBalance num={row.amount} /></Typography></TableCell>
                                    <TableCell><Typography sx={{ fontWeight: 500 }} variant='h6'><ReturnNumber num={row.amount * row.value} />&nbsp;{row.currency_id}</Typography></TableCell>

                                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                                        <Typography variant='h6'>
                                            {dayjs(row.created_at).format("DD MMM YYYY, HH:mm")}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                                        {isWaitingForPayment ? (
                                            <Box
                                                sx={{
                                                    display: 'inline-block',
                                                    backgroundColor: palette.success,
                                                    color: 'white',
                                                    padding: '5px 10px',
                                                    borderRadius: '12px',
                                                    fontWeight: 'bold',
                                                    animation: 'pulse 1.5s ease-in-out infinite',
                                                }}
                                            >
                                                Ждет оплату
                                            </Box>
                                        ) : (
                                            <Chip
                                                sx={{ fontSize: '16px' }}
                                                label={row.status_id}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h6'>
                                            {row.login}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                                        {isWaitingForPayment && (
                                            <Typography variant="h6" sx={{ fontWeight: 600, color: palette.error, minWidth: "120px" }}>
                                                <>
                                                    {Number(row.final_at) * 1000 > Date.now() ? (
                                                        <>Осталось <TimerForTable finalAt={Number(row.final_at)} /></>
                                                    ) : (
                                                        "Время на оплату вышло"
                                                    )}
                                                </>
                                            </Typography>
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {/* <pre>
                                            {JSON.stringify(row, null, 2)}
                                        </pre> */}

                                        {isWaitingForPayment &&
                                            <IconButton onClick={() => {
                                                setActiveAds(row);
                                                updateStateModal(true)
                                            }}>
                                                <Tooltip title="Загрузить подтверждение оплаты">
                                                    <IconCameraUp />
                                                </Tooltip>
                                            </IconButton>
                                        }
                                        {row?.path &&
                                            <>
                                                <a href={row?.path} target="_blank" rel="noreferrer">
                                                    <Avatar
                                                        src={row.path}
                                                        sx={{ borderRadius: "4px" }}
                                                    />
                                                </a>
                                            </>
                                        }

                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                {/* <Pagination count={Math.ceil(50)} page={currentPage} onChange={(_, value) => setCurrentPage(value)} variant="outlined" shape="rounded" /> */}
            </Box>

            {/* Модальное окно для создания нового реквизита */}
            <Dialog fullWidth={true} maxWidth="lg" open={openModal} onClose={() => setOpenModal(false)}>
                <IconButton sx={{ background: palette.errorLight, position: 'absolute', top: '.5rem', right: '.5rem' }}
                    onClick={() => updateStateModal(false)}>
                    <CloseRoundedIcon sx={{ color: palette.error }} />
                </IconButton>
                <DialogTitle>Управление</DialogTitle>
                <DialogContent sx={{ position: 'relative' }}>
                    <Box display='flex' alignItems='center' minHeight={300}>
                        {/* {JSON.stringify(activeAds)} */}
                        {/* <SetPurchase active={activeAds} reload={updateStateModal} /> */}
                        <LoadImgForAds id={activeAds} updateState={updateStateModal} reload={updateReload} />
                    </Box>
                </DialogContent>
            </Dialog>

            <style>{`
                @keyframes pulse {
                    0% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.1); opacity: 0.8; }
                    100% { transform: scale(1); opacity: 1; }
                }
            `}</style>
        </>
    );
};